<!-- Mobile Nav Bar -->
<div class="mobile-nav">
  <a
    [hidden]="isShow"
    href="assets/ComputerScienceResume.pdf"
    target="_blank"
    class="visualResume"
    >RESUME</a
  >
  <mat-expansion-panel hideToggle #first="matExpansionPanel" (click)="resume()">
    <mat-expansion-panel-header>
      <mat-panel-title> Menu </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-action-row mat-button (click)="close(first)" routerLink="/Work"
      >work</mat-action-row
    >
    <mat-action-row mat-button (click)="close(first)" routerLink="/About"
      >about</mat-action-row
    >
    <mat-action-row mat-button (click)="close(first)" routerLink="/Art"
      >art</mat-action-row
    >
  </mat-expansion-panel>
</div>

<nav class="nav-bar" SameSite="Strict">
  <div class="name">
    <a routerLink="" class="name"> Manasvi Medam </a>
  </div>

  <div class="laptop-nav">
    <ul class="tabs">
      <li>
        <a routerLink="/Work">work</a>
      </li>
      <li>
        <a routerLink="/About">about</a>
      </li>
      <li>
        <a href="assets/ComputerScienceResume.pdf" target="_blank">resume</a>
      </li>
      <li><a href="#" routerLink="/Art">art</a></li>
    </ul>
  </div>
</nav>
